// 330, // applicationFee
// 660, // establishmentFee
// 550, // legalFee
// 70, // verificationValuationFee
// 15 // monthlyFee

import {
  applicationFeeForPersonal,
  applicationFeeForUsed,
  establishmentFee,
  legalFee,
  verificationValuationFee,
  monthlyFee,
} from "app/constants/loanCalculateFee";

function calculateLoan(
  purchasePrice: number,
  contribution: number,
  annualRentalRate: number,
  loanTermInYears: number,
  balloonPercentage: number,
  loanFor: string
) {
  // console.log("🚀 ~ calculateLoan ~ annualRentalRate:", {
  //   purchasePrice,
  //   contribution,
  //   annualRentalRate,
  //   loanTermInYears,
  //   balloonPercentage,
  //   loanFor,
  // });

  const applicationFee =
    loanFor === "personal" ? applicationFeeForPersonal : applicationFeeForUsed;

  // const establishmentFee = 660; old fee

  // const legalFee = legalFee;
  // const verificationValuationFee = 70;
  // const monthlyFee = 15;

  // Input validation
  if (
    purchasePrice <= 0 ||
    contribution < 0 ||
    annualRentalRate < 0 ||
    loanTermInYears <= 0 ||
    balloonPercentage < 0 ||
    applicationFee < 0 ||
    legalFee < 0 ||
    verificationValuationFee < 0 ||
    monthlyFee < 0
  ) {
    return { error: "Invalid input values" };
  }

  // Calculations
  const loanRequired = purchasePrice - contribution;

  const estFee = (2.75 / 100) * loanRequired;
  let establishmentFee = 0;

  if (loanFor === "personal") {
    establishmentFee = estFee < 650 ? 650 : estFee;
  } else {
    establishmentFee = estFee < 800 ? 800 : estFee;
  }

  // const establishmentFee = 825;

  const totalFees =
    applicationFee + establishmentFee + legalFee + verificationValuationFee;

  const totalFinanceAmount = loanRequired + totalFees;
  const lvr = (loanRequired / purchasePrice) * 100;
  const balloonPayment = (balloonPercentage / 100) * purchasePrice;

  const monthlyRentalRate = annualRentalRate / 100 / 12;
  const loanTermInMonths = loanTermInYears * 12;

  // Calculate monthly payment for the full amount, adjusted for balloon
  const monthlyPayment =
    (totalFinanceAmount * monthlyRentalRate) /
    (1 - Math.pow(1 + monthlyRentalRate, -loanTermInMonths));
  const totalPayments = monthlyPayment * loanTermInMonths;
  const remainingBalance =
    totalFinanceAmount * Math.pow(1 + monthlyRentalRate, loanTermInMonths) -
    (monthlyPayment * (Math.pow(1 + monthlyRentalRate, loanTermInMonths) - 1)) /
      monthlyRentalRate;

  // Adjust monthlyPayment to match the balloon payment at the end
  const adjustedMonthlyPayment =
    (totalFinanceAmount -
      balloonPayment * Math.pow(1 + monthlyRentalRate, -loanTermInMonths)) *
    (monthlyRentalRate /
      (1 - Math.pow(1 + monthlyRentalRate, -loanTermInMonths)));

  const totalInterest =
    adjustedMonthlyPayment * loanTermInMonths -
    (totalFinanceAmount - balloonPayment);
  const totalRentalCharged = totalInterest + monthlyFee * loanTermInMonths;
  const stressedLoanPayments = adjustedMonthlyPayment + monthlyFee;

  return {
    loanRequired: loanRequired.toFixed(2),
    totalFinanceAmount: totalFinanceAmount.toFixed(2),
    lvr: lvr.toFixed(2),
    balloonPayment: balloonPayment.toFixed(2),
    monthlyPayment: adjustedMonthlyPayment.toFixed(2),
    totalRentalCharged: totalRentalCharged.toFixed(2),
    stressedLoanPayments: stressedLoanPayments.toFixed(2),
    establishmentFee,
  };
}

export { calculateLoan };

// Test
// Example usage with values from the image
// const result = calculateLoan(
//   40000, // purchasePrice
//   16000, // contribution
//   10.59, // annualRentalRate
//   3, // loanTermInYears
//   20, // balloonPercentage
//   330, // applicationFee
//   660, // establishmentFee
//   660, // legalFee
//   550, // verificationValuationFee
//   70, // brokerageFee
//   15 // monthlyFee
// );
